export const formatReportTitle = (rhName, sName, pName) => {
    let nameString = `${rhName}`;
    if (sName) nameString += ` - ${sName}`;
    if (pName) nameString += ` - ${pName}`;
    return nameString;
};
